var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1404 225L1404 253",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1404.5,
    cy: 220.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1404 229L1397 225.2V219.2L1393 217L1404 211L1415 217V225H1413V218.1L1411 219.2V225.2L1404 229ZM1404 220.7L1410.85 217L1404 213.3L1397.15 217L1404 220.7ZM1404 226.725L1409 224.025V220.25L1404 223L1399 220.25V224.025L1404 226.725Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool5);
export default __webpack_public_path__ + "static/media/school_5.a790a60177b41d9dc3ba174da80e498c.svg";
export { ForwardRef as ReactComponent };